export const REQUEST_ERROR = "requestError";
export const AUTH_ERROR = "noLogin";